import type {
  Destinatario,
  OperadorComparacion,
  TipoDestinatario,
  TipoDeVariable,
} from "../services/notificaciones-service";

// Etiquetas y reglas de UI que espejan las del backend (EvaluadorDeCondiciones, §3.2 de la spec).

export const ETIQUETA_OPERADOR: Record<OperadorComparacion, string> = {
  Igual: "es igual a",
  Distinto: "es distinto de",
  Mayor: "es mayor que",
  MayorOIgual: "es mayor o igual que",
  Menor: "es menor que",
  MenorOIgual: "es menor o igual que",
  Contiene: "contiene",
  NoContiene: "no contiene",
  EmpiezaCon: "empieza con",
  EnLista: "está en la lista",
  NoEnLista: "no está en la lista",
  Vacio: "está vacío",
  NoVacio: "tiene valor",
};

const PRESENCIA: OperadorComparacion[] = ["Vacio", "NoVacio"];

/** Operadores válidos por tipo de variable (mismo mapa que el backend valida al publicar). */
export const OPERADORES_POR_TIPO: Record<TipoDeVariable, OperadorComparacion[]> = {
  Texto: ["Igual", "Distinto", "Contiene", "NoContiene", "EmpiezaCon", "EnLista", "NoEnLista", ...PRESENCIA],
  Numero: ["Igual", "Distinto", "Mayor", "MayorOIgual", "Menor", "MenorOIgual", "EnLista", "NoEnLista", ...PRESENCIA],
  Fecha: ["Igual", "Distinto", "Mayor", "MayorOIgual", "Menor", "MenorOIgual", "EnLista", "NoEnLista", ...PRESENCIA],
  FechaHora: ["Igual", "Distinto", "Mayor", "MayorOIgual", "Menor", "MenorOIgual", "EnLista", "NoEnLista", ...PRESENCIA],
  Booleano: ["Igual", "Distinto", ...PRESENCIA],
  Lista: ["Contiene", "NoContiene", "EnLista", "NoEnLista", ...PRESENCIA],
  Identificador: ["Igual", "Distinto", "EnLista", "NoEnLista", ...PRESENCIA],
};

export function operadorSinValor(op: OperadorComparacion): boolean {
  return op === "Vacio" || op === "NoVacio";
}

export function ayudaValor(tipo: TipoDeVariable, op: OperadorComparacion): string {
  if (op === "EnLista" || op === "NoEnLista") return "Valores separados por coma";
  switch (tipo) {
    case "Numero": return "Número, p. ej. 500000";
    case "Fecha": return "Fecha aaaa-mm-dd";
    case "FechaHora": return "Fecha aaaa-mm-dd (o fecha y hora ISO)";
    case "Booleano": return "true o false";
    default: return "Texto";
  }
}

export const ETIQUETA_DESTINATARIO: Record<TipoDestinatario, string> = {
  Fijo: "Dirección fija",
  SolicitanteODueno: "Solicitante / dueño",
  AutorizadoresDelNivel: "Autorizadores del nivel",
  UsuariosConRol: "Usuarios con un rol",
  Actor: "Quien hizo el cambio",
  UsuarioEspecifico: "Un usuario específico",
  ResponsablesDelTipoCatalogo: "Responsables del tipo de solicitud de catálogo",
  RevisoresDocumentales: "Revisores documentales",
};

export const AYUDA_DESTINATARIO: Record<TipoDestinatario, string> = {
  Fijo: "Una dirección fija: correo, número E.164 o chat de Telegram según el canal.",
  SolicitanteODueno: "Dueño del recurso del evento: el solicitante de la solicitud o el usuario afectado.",
  AutorizadoresDelNivel: "Solo en eventos de nivel pendiente: usuarios con los roles del nivel en la organización.",
  UsuariosConRol: "Todos los usuarios del rol; opcionalmente solo los de la organización del evento.",
  Actor: "El usuario que provocó el evento.",
  UsuarioEspecifico: "Un usuario elegido de la lista.",
  ResponsablesDelTipoCatalogo:
    "Solo en solicitudes de catálogo creadas o canceladas: usuarios con los roles responsables del tipo (configurados en Tipos de solicitud de catálogo).",
  RevisoresDocumentales:
    "Solo en documentos enviados a revisión: usuarios con los roles revisores de la categoría o tipo del documento (sin incluir al solicitante).",
};

export function resumenDestinatarios(destinatarios: Destinatario[]): string {
  if (destinatarios.length === 0) return "Sin destinatarios";
  const partes = destinatarios.map((d) =>
    d.tipo === "Fijo" || d.tipo === "UsuariosConRol" ? d.valor || ETIQUETA_DESTINATARIO[d.tipo] : ETIQUETA_DESTINATARIO[d.tipo],
  );
  return partes.length > 2 ? `${partes.slice(0, 2).join(", ")} +${partes.length - 2}` : partes.join(", ");
}
